// src/pages/LoginPage.tsx
import React from 'react';
import { Form, Input, Button, Card, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/useAuthStore';

const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const login = useAuthStore((state) => state.login);

  const onFinish = (values: { email: string; password: string }) => {
    const success = login(values.email, values.password);
    
    if (success) {
      message.success('¡Inicio de sesión exitoso!');
      navigate('/dashboard');
    } else {
      message.error('Credenciales inválidas');
    }
  };

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
    }}>
      <Card 
        title="HR Partner Pro" 
        style={{ width: 400, boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}
      >
        <Form
          name="login"
          onFinish={onFinish}
          autoComplete="off"
          layout="vertical"
        >
          <Form.Item
            label="Email"
            name="email"
            rules={[
              { required: true, message: 'Por favor ingrese su email' },
              { type: 'email', message: 'Ingrese un email válido' }
            ]}
          >
            <Input 
              prefix={<UserOutlined />} 
              placeholder="admin@hrpro.com" 
              size="large"
            />
          </Form.Item>

          <Form.Item
            label="Contraseña"
            name="password"
            rules={[{ required: true, message: 'Por favor ingrese su contraseña' }]}
          >
            <Input.Password 
              prefix={<LockOutlined />} 
              placeholder="Contraseña" 
              size="large"
            />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" block size="large">
              Iniciar Sesión
            </Button>
          </Form.Item>
        </Form>
        
        <div style={{ marginTop: 16, fontSize: 12, color: '#666' }}>
          <p><strong>Usuarios de prueba:</strong></p>
          <p>Admin: admin@hrpro.com</p>
          <p>Cliente Acme: client@acme.com</p>
          <p>Cliente Beta: client@beta.com</p>
          <p style={{ marginTop: 8, fontStyle: 'italic' }}>Cualquier contraseña funciona</p>
        </div>
      </Card>
    </div>
  );
};

export default LoginPage;
